import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-share-icon",
  "use": "icon-share-icon-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" fill=\"none\" id=\"icon-share-icon\">\r\n<path stroke=\"rgba(0, 98, 255, 1)\" stroke-width=\"1.3333333730697632\" stroke-linejoin=\"round\" stroke-linecap=\"round\" style=\"mix-blend-mode:normal\" d=\"M9.33337 2L14 2L14 6.66667\">\r\n</path>\r\n<path stroke=\"rgba(0, 98, 255, 1)\" stroke-width=\"1.3333333730697632\" stroke-linejoin=\"round\" stroke-linecap=\"round\" style=\"mix-blend-mode:normal\" d=\"M14 9.82457L14 13C14 13.5523 13.5523 14 13 14L3 14C2.44772 14 2 13.5523 2 13L2 3C2 2.44772 2.44772 2 3 2L6 2\">\r\n</path>\r\n<path stroke=\"rgba(0, 98, 255, 1)\" stroke-width=\"1.3333333730697632\" stroke-linejoin=\"round\" stroke-linecap=\"round\" style=\"mix-blend-mode:normal\" d=\"M8.59998 7.40005L13.7 2.30005\">\r\n</path>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/share-icon.svg
// module id = J0nw
// module chunks = 115